import { Link } from "react-router-dom";
import { SignedIn } from "./auth/SignedIn";

const Footer = () => {
  const FooterContent = () => {
    return (
      <footer className="hidden md:flex flex-col sm:flex-row justify-between items-center border-t-[0.5px] border-gray-600 py-5 sm:px-6 lg:px-8 bg-black text-sm text-gray-600">
        <div className="mb-4 sm:mb-0 text-center sm:text-left items-center">
          <Link
            to="https://pulse-date.com/terms"
            className="mr-4 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </Link>
          <Link
            to="https://pulse-date.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Privacy
          </Link>
        </div>
        <div className="text-center sm:text-right items-center">
          © 2025 Pulse. All Rights Reserved.
        </div>
      </footer>
    );
  };

  return <SignedIn fallback={<FooterContent />}>{null}</SignedIn>;
};

export default Footer;
